import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Legend from 'components/common/Legend/Legend'
import Button from 'components/common/Button/Button'
import * as UI from './Shared.styles'

const PasswordAndSecurityView = ({
  accountContactDetails: {
    emailId
  } = {},
  onEdit
}) =>
  <Fragment>
    <Legend label="User Email" data-at-accountdetails-useremail>{ emailId }</Legend>
    <Legend label="Password" data-at-accountdetails-password>Your password is hidden by default. Select “EDIT” to change your password.</Legend>
    <UI.Buttons>
      <Button data-at-security-edit-button onClick={ onEdit }>Edit</Button>
    </UI.Buttons>
  </Fragment>

export default PasswordAndSecurityView

PasswordAndSecurityView.propTypes = {
  accountContactDetails: PropTypes.shape(),
  onEdit: PropTypes.func
}
